import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaymentSchedule} from './getPaymentSchedule.api';
import {updateCacheByType} from '../../graphql/GraphQlProvider';
import {PaymentSchedule} from '../../graphql/payment_schedule.datatypes';

interface PaymentScheduleDateVars {
    id?: number
    title?: string
    due_date?: string
    action_type?: number
    amount?: number
    amount_type?: number
}

export interface UpdatePaymentScheduleVars {
    data: {
        id: number,
        description: string,

        dates: {
            create?: PaymentScheduleDateVars[],
            update?: PaymentScheduleDateVars[],
            delete?: number[],
        }
    };
}

interface UpdatePaymentScheduleData {
    __typename?: string,
    updatePaymentSchedule: PaymentSchedule
}

export const UPDATE_PAYMENT_SCHEDULE_MUTATION = gql`
    mutation updatePaymentSchedule($data: UpdatePaymentScheduleInput!) {
        updatePaymentSchedule(data: $data) {
            ${gqlPaymentSchedule}
        }
    }
`;

export const updatePaymentSchedule = () => useMutation<UpdatePaymentScheduleData, UpdatePaymentScheduleVars>(
    UPDATE_PAYMENT_SCHEDULE_MUTATION,
    {
        // update: updateCacheByType('PaymentSchedule'),
    }
);

export default updatePaymentSchedule;
